import type { TOC } from '@ember/component/template-only';
import type { ItemDetailsSignature } from './utils.gts';

/** Card details for movie & tv_show: overview + release year */
const MovieDetails: TOC<ItemDetailsSignature> = <template>
  {{#if (overview @data)}}
    <p
      class="text-base-content/70 mt-1 line-clamp-2 min-w-0 text-sm break-words"
    >
      {{overview @data}}
    </p>
  {{/if}}
  {{#if (releaseYear @data)}}
    <span class="text-base-content/50 text-xs">{{releaseYear @data}}</span>
  {{/if}}
</template>;

function overview(data: Record<string, unknown> | null): string | null {
  return (data?.overview as string) ?? null;
}

function releaseYear(data: Record<string, unknown> | null): string | null {
  const date = (data?.releaseDate ?? data?.firstAirDate) as string | undefined;
  if (!date) return null;
  return date.slice(0, 4);
}

export default MovieDetails;
